"use strict";
import Splide from "@splidejs/splide";

export default function () {
    document.addEventListener("DOMContentLoaded", () => {
        const seguroSlider = document.querySelector(
            ".o-seguro-frota__cards.splide"
        );
        if (!seguroSlider) return;

        const splide = new Splide(seguroSlider, {
            type: "loop",
            perPage: 4,
            autoplay: false,
            interval: 5000,
            speed: 800,
            drag: false,
            pauseOnHover: true,
            arrows: false,
            pagination: false,
            gap: "1.938rem",
            breakpoints: {
                1024: {
                    perPage: 2,
                    drag: true,
                    autoplay: true,
                },
                680: {
                    perPage: 1,
                },
            },
        });

        splide.mount();
    });
}
